// Design renders the equivalence suffix spaced: `kg CO2-Eq` -> `kg CO2 - Eq`.
// Anchored on the `Eq` token so hyphens inside a substance name (`kg CFC-11-Eq`) are left alone.
const EQ_SUFFIX = /-Eq\b/g;

export const formatLciaUnit = (unit: string): string => unit.replace(EQ_SUFFIX, ' - Eq');
